module.exports = __webpack_public_path__ + "static-portal/img/login-1.b0546d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-1.png
// module id = +MUi
// module chunks = 4